<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5 23C18.299 23 23 18.299 23 12.5C23 6.70101 18.299 2 12.5 2C6.70101 2 2 6.70101 2 12.5C2 18.299 6.70101 23 12.5 23ZM7.90381 9.31802L15.682 17.0962L17.0962 15.682L9.31802 7.90381L7.90381 9.31802Z"
      fill="currentColor"
    />
    <path d="M16.3892 8.61133L8.61099 16.3895" stroke="white" stroke-width="2" />
  </svg>
</template>
